module.exports = __webpack_public_path__ + "img/msins-logo-white.b3e66597.png";